class CollectionBubbles extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-bubbles-track]');
    this.prevBtn = this.querySelector('[data-bubbles-prev]');
    this.nextBtn = this.querySelector('[data-bubbles-next]');

    if (!this.track) return;

    this._onPrev = () => this.scrollByStep(-1);
    this._onNext = () => this.scrollByStep(1);
    this._onScroll = () => this.updateState();
    this._onResize = () => this.updateState();

    this.prevBtn?.addEventListener('click', this._onPrev);
    this.nextBtn?.addEventListener('click', this._onNext);
    this.track.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onResize);

    // Re-check after images load, since natural overflow can change layout.
    this.track.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', this._onResize, { once: true });
    });

    this.updateState();
  }

  disconnectedCallback() {
    this.prevBtn?.removeEventListener('click', this._onPrev);
    this.nextBtn?.removeEventListener('click', this._onNext);
    this.track?.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onResize);
  }

  scrollByStep(direction) {
    if (!this.track) return;
    const amount = this.track.clientWidth * 0.8 * direction;
    this.track.scrollBy({ left: amount, behavior: 'smooth' });
  }

  updateState() {
    if (!this.track) return;
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const hasOverflow = scrollWidth - clientWidth > 1;

    this.classList.toggle('collection-bubbles--has-overflow', hasOverflow);

    if (this.prevBtn) this.prevBtn.disabled = scrollLeft <= 1;
    if (this.nextBtn) this.nextBtn.disabled = scrollLeft >= scrollWidth - clientWidth - 1;
  }
}

if (!customElements.get('collection-bubbles')) {
  customElements.define('collection-bubbles', CollectionBubbles);
}